import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Typography, Space, Divider } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import Loader from '../ReusableComponents/Loader';
import { toastError, toastWarn } from '../Toast/ToastComponent';
import { TrainingsApi } from '../../Api/TrainingsApi';
import { useAuth } from '../../Context/AuthContext';

const { Text } = Typography;
const TraineeAttendance = ({ onDataLoad }) => {
  const { authState } = useAuth();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);
  const [trainingDetails, setTrainingDetails] = useState({});
  const training_id =
    location?.state?.training_id ||
    location?.state?.overviewData?.training_details?.id;
  useEffect(() => {
    if (training_id) {
      getAttendance();
    }
  }, [training_id]);
  const getAttendance = async () => {
    try {
      setLoading(true);

      const payload = {
        training_id: training_id,
        trainee_id: authState?.id,
      };
      const res = await TrainingsApi.getTraineeWiseAttendance(payload);
      if (res?.data?.success) {
        const result = res?.data?.result;
        if (result?.attendance) {
          setAttendanceData(result.attendance);
          const details = result.training_details || {};
          setTrainingDetails(details);
          if (onDataLoad) onDataLoad(details);
        } else if (Array.isArray(result)) {
          setAttendanceData(result);
        } else {
          setAttendanceData(result ? [result] : []);
        }
      } else {
        toastWarn(res?.data?.message || 'No attendance found');
      }
    } catch (err) {
      toastError(err?.response?.data?.message || err?.message);
    } finally {
      setLoading(false);
    }
  };
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB');
  };

  return (
    <div
      style={{
        background: '#fff',
        padding: '0px 24px',
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <div
          style={{ maxWidth: '1200px', margin: '0 auto', paddingTop: '16px' }}
        >
          {attendanceData.map((item) => {
            const myAttendance =
              item?.attendance_details?.find(
                (x) => x.user_id === authState?.id,
              ) || item;
            const isPresent = myAttendance?.status?.toLowerCase() === 'present';
            const isAbsent = myAttendance?.status?.toLowerCase() === 'absent';
            return (
              <Card
                key={item.day}
                style={{
                  marginBottom: 16,
                  borderRadius: 2,
                  border: '1px solid #f0f0f0',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                }}
                bodyStyle={{ padding: '16px 20px' }}
              >
                <Row align="middle" gutter={20}>
                  <Col>
                    <div
                      style={{
                        width: 50,
                        height: 50,
                        backgroundColor: '#1b67b3',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontWeight: 500,
                        fontSize: '14px',
                      }}
                    >
                      Day {item.day}
                    </div>
                  </Col>
                  <Col flex="auto">
                    <Space
                      direction="vertical"
                      size={2}
                      style={{ width: '100%' }}
                    >
                      <Space size={8} align="center">
                        <Text
                          strong
                          style={{
                            fontSize: 18,
                            color: '#262626',
                          }}
                        >
                          {formatDate(item.session_date)}
                        </Text>
                        <Divider
                          type="vertical"
                          style={{
                            height: 20,
                            borderColor: '#bfbfbf',
                            margin: '0 8px',
                          }}
                        />
                        <Space size={4}>
                          <Text type="secondary" style={{ fontSize: '13px' }}>
                            Check In :
                          </Text>
                          <Text
                            strong
                            style={{
                              fontSize: '13px',
                              color: item.check_in_time ? '#262626' : '#bfbfbf',
                            }}
                          >
                            {item.check_in_time || '--'}
                          </Text>
                        </Space>
                        <Divider
                          type="vertical"
                          style={{ borderColor: '#d9d9d9', margin: '0 4px' }}
                        />
                        <Space size={4}>
                          <Text type="secondary" style={{ fontSize: '13px' }}>
                            Check Out :
                          </Text>
                          <Text
                            strong
                            style={{
                              fontSize: '13px',
                              color: item.check_out_time
                                ? '#262626'
                                : '#bfbfbf',
                            }}
                          >
                            {item.check_out_time || '--'}
                          </Text>
                        </Space>
                      </Space>
                    </Space>
                  </Col>
                  <Col>
                    {isPresent ? (
                      <div
                        style={{
                          backgroundColor: '#f6ffed',
                          border: '1px solid #b7eb8f',
                          borderRadius: '4px',
                          padding: '6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          color: '#52c41a',
                          minWidth: '100px',
                          justifyContent: 'center',
                        }}
                      >
                        <CheckCircleOutlined style={{ fontSize: '16px' }} />
                        <Text style={{ color: '#52c41a', fontWeight: 500 }}>
                          Present
                        </Text>
                      </div>
                    ) : isAbsent ? (
                      <div
                        style={{
                          backgroundColor: '#fff1f0',
                          border: '1px solid #ffa39e',
                          borderRadius: '4px',
                          padding: '6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          color: '#ff4d4f',
                          minWidth: '100px',
                          justifyContent: 'center',
                        }}
                      >
                        <CloseCircleOutlined style={{ fontSize: '16px' }} />
                        <Text style={{ color: '#ff4d4f', fontWeight: 500 }}>
                          Absent
                        </Text>
                      </div>
                    ) : (
                      <div
                        style={{
                          backgroundColor: '#f5f5f5',
                          border: '1px solid #d9d9d9',
                          borderRadius: '4px',
                          padding: '6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          color: '#8c8c8c',
                          minWidth: '100px',
                          justifyContent: 'center',
                        }}
                      >
                        <Text style={{ color: '#8c8c8c', fontWeight: 500 }}>
                          Pending
                        </Text>
                      </div>
                    )}
                  </Col>
                </Row>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};
export default TraineeAttendance;
